import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Calculate days remaining until challenge end.
 * Normalizes both dates to midnight for accurate calendar day calculation.
 * Returns a value between 0 and 365 (inclusive).
 */
export function calculateDaysRemaining(challengeEnd: string | Date): number {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  const end = new Date(challengeEnd);
  end.setHours(0, 0, 0, 0);
  
  const diffMs = end.getTime() - today.getTime();
  const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
  
  return Math.min(365, Math.max(0, diffDays));
}
